module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="daterangepicker dropdown-menu">\n    <i class="close-dropdown-icon fal fa-times"></i>\n    <div class="top-wrap">\n        ';
 if (data.has_datetype) { ;
__p += '\n        <div class="datetype-picker pz-radio-buttons-2"></div>\n        ';
 } ;
__p += '\n        <div class="second-line-controls">\n            ';
 if (data.calendars.length > 1) { ;
__p += '\n            <div class="viewby-picker">\n                ';
 data.calendars.forEach(function(view) { ;
__p += '\n                <div data-viewby="' +
((__t = ( view )) == null ? '' : __t) +
'" class="view-by ' +
((__t = ( view === data.activeCalendar ? 'active' : '')) == null ? '' : __t) +
'">' +
((__t = ( view.charAt(0).toUpperCase() + view.slice(1) )) == null ? '' : __t) +
'</div>\n                ';
 }) ;
__p += '\n            </div>\n            ';
 } ;
__p += '\n            ';
 if (data.has_date_comparison) { ;
__p += '\n            <div class="calendar-tabs"></div>\n            ';
 } ;
__p += '\n        </div>\n\n    </div>\n    <div class="calendar-wrap">\n        <div class="ranges">\n            <ul class="range-list"></ul>\n        </div>\n        ';
 if (data.activeCalendar === "day") { ;
__p += '\n        <div class="calendar left">\n            <div class="daterangepicker_input">\n                <input class="input-mini form-control" type="text" name="daterangepicker_start" value="">\n                <i class="fal fa-calendar-alt calendar-icon"></i>\n            </div>\n            <div class="calendar-table"></div>\n        </div>\n        <div class="calendar right">\n            <div class="daterangepicker_input">\n                <input class="input-mini form-control" type="text" name="daterangepicker_end" value="" />\n                <i class="fal fa-calendar-alt calendar-icon"></i>\n            </div>\n            <div class="calendar-table"></div>\n        </div>\n        ';
 } else if (data.activeCalendar === "month") { ;
__p += '\n        <div class="calendar-monthly">\n            <div class="month-picker"></div>\n        </div>\n        ';
 } else if (data.activeCalendar === "quarter") { ;
__p += '\n        <div class="calendar-quarterly">\n            <div class="quarter-picker"></div>\n        </div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="datepicker-footer">\n        ';
 if (data.has_data_availability || data.has_data_availability_legend) { ;
__p += '\n        <div class="data-availability-legend">\n            <div class="title go-to-data-status">Data status</div>\n        </div>\n        ';
 } ;
__p += '\n        <button class="applyBtn" disabled="disabled" type="button"></button>\n    </div>\n</div>\n';
return __p
}